export default "__VITE_ASSET__DrzT9EOm__"